let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gyR8g")).then(() => parcelRequire('g42kD'));